import React, { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface HeaderDropdownProps {
  icon: React.ReactNode;
  label: string;
  menuLabel: string;
  triggerClassName?: string;
  menuClassName?: string;
  children: (close: () => void) => React.ReactNode;
}

/** Trigger + floating menu used by every control in the dashboard header. */
export function HeaderDropdown({
  icon,
  label,
  menuLabel,
  triggerClassName = 'w-52',
  menuClassName = 'w-64',
  children
}: HeaderDropdownProps) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return undefined;
    function handlePointerDown(event: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) setOpen(false);
    }
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);
  return <div ref={containerRef} className="relative" data-id="element-307" data-mp="2up3u6c6qdu06">
      <button type="button" aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen(state => !state)} className={`inline-flex items-center gap-2 rounded-lg border border-slate-300 bg-white px-3.5 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 ${triggerClassName}`} data-id="element-308" data-mp="2znyks0axwmuu">
        {icon}
        <span className="flex-1 truncate text-left" data-id="element-309" data-mp="2bsvwbtg1slew">{label}</span>
        <ChevronDownIcon className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-310" data-mp="2gq4hm2wht5kd" />
      </button>
      {open ? <div role="listbox" aria-label={menuLabel} className={`absolute right-0 z-30 mt-2 max-h-96 overflow-y-auto rounded-lg border border-slate-200 bg-white py-1 shadow-lg ${menuClassName}`} data-id="element-311" data-mp="expqqebz0qrt">
          {children(() => setOpen(false))}
        </div> : null}
    </div>;
}